export default {
	state: {
		loginShow: false,//是否显示登录
		isService: false,
		topBannerData: "",//顶部banner
		isWelfareRed: false,
		informationMsgIdStr: "",
		channel: "10000",
		appid: "188888",
	},
	mutations: {
		LoginShow(state, loginShow) {
			state.loginShow = loginShow
		},
		IsService(state, isService) {
			state.isService = isService
		},
		TopBannerData(state, topBannerData) {
			state.topBannerData = topBannerData
		},
		IsWelfareRed(state, isWelfareRed) {
			state.isWelfareRed = isWelfareRed
		},
		InformationMsgIdStr(state, informationMsgIdStr) {
			state.informationMsgIdStr = informationMsgIdStr ? informationMsgIdStr + '-' + parseInt(Math.random() * 10000) : informationMsgIdStr;
		},
	},

	actions: {
		LoginShowFun(context, n) {
			context.commit('LoginShow', n)
		},
		IsServiceFun(context, n) {
			context.commit('IsService', n)
		},
		TopBannerDataFun(context, n) {
			context.commit('TopBannerData', n)
		},
		IsWelfareRedFun(context, n) {
			context.commit('IsWelfareRed', n)
		},
		InformationMsgIdStrFun(context, n) {
			context.commit('InformationMsgIdStr', n)
		},
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/mobile.js